import type { SessionEvent } from "../core/types"

function now(): string {
  return new Date().toISOString()
}

export function captureScreenView(screen: string, params?: Record<string, any>): SessionEvent {
  return {
    type: "page_view",
    ts: now(),
    target: "",
    path: screen,
    text: screen,
    meta: { screen, ...((params || {}) as Record<string, string | number | boolean>) },
  }
}

export function captureScreenLeave(screen: string, dwellMs: number): SessionEvent {
  return {
    type: "page_leave",
    ts: now(),
    target: "",
    path: screen,
    text: "",
    meta: { screen, dwell_ms: Math.max(0, Math.round(dwellMs)) },
  }
}

export function capturePress(target: string, properties?: Record<string, any>): SessionEvent {
  return {
    type: "click",
    ts: now(),
    target: target || "touch",
    path: (properties && typeof properties.screen === "string" && properties.screen) || "",
    text: target || "",
    meta: { input: "touch", ...((properties || {}) as Record<string, string | number | boolean>) },
  }
}

export function captureNativeError(message: string, stack?: string): SessionEvent {
  const msg = String(message || "Unknown error").slice(0, 500)
  return {
    type: "error",
    ts: now(),
    target: "ErrorUtils.globalHandler",
    path: "",
    text: msg.slice(0, 300),
    meta: { message: msg, stack: String(stack || "").slice(0, 2000) },
  }
}
